import logoUrl from '../assets/rconf-logo.svg';
import './startup-loader.css';

export function StartupLoader({ label = 'Открываем личный кабинет…', compact = false }: { label?: string; compact?: boolean }) {
  return <div className={`startup-loader${compact ? ' startup-loader--compact' : ''}`} role="status" aria-live="polite">
    <div className="startup-loader__brand" aria-hidden="true"><span className="startup-loader__halo" /><img src={logoUrl} alt="" /><span className="startup-loader__word">RConf</span></div>
    <p>{label}</p><div className="startup-loader__track" aria-hidden="true"><span /></div>
  </div>;
}
